module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs structure"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "structure-box"
  }, [_c('div', {
    staticClass: "finish-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.productStructure.thumbnail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h1', [_vm._v(_vm._s(_vm.productStructure.name))]), _vm._v(" "), _c('p', [_vm._v("规格：" + _vm._s(_vm.productStructure.specification))])])]), _vm._v(" "), _c('structure', {
    attrs: {
      "structureList": _vm.structureList
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb9876d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/bom-bill/structure.vue
// module id = 1267
// module chunks = 82